<div class="welcome-page-wrapper">

  <!-- HERO: map + 2 cards -->
  <div class="dashboard-hero">

    <!-- Born today -->
    <div class="slot dc-1">
      @defer (on idle) {
      @if (randomBirthday) {
      <div class="dash-card">

        <!-- Header -->
        <div class="dash-card-header"
          (click)="goToCalendar()">
          <span class="dash-card-title">{{currentDate | translit}}</span>
          <span class="dash-card-subtitle">{{'Рођени на данашњи дан' | translit}}</span>
        </div>

        <!-- Portrait trio -->
        <div class="dash-card-body">
          <div class="birthday-cards">

            <!-- Side left -->
            @if (prevBirthday) {
            <div class="bcard bcard-side bcard-left"
              (click)="prevBirthdayClick($event)">
              <img class="bcard-side-img"
                loading="lazy"
                [src]="prevBirthday.imagePath"
                [alt]="prevBirthday.commonName">
            </div>
            }

            <!-- Center -->
            <div class="bcard bcard-center"
              (click)="goToPerson(randomBirthday.slug!)">
              <div class="bcard-portrait">
                <img loading="lazy"
                  [src]="randomBirthday.imagePath"
                  [alt]="randomBirthday.commonName">
              </div>
              <span class="bcard-name">{{randomBirthday.commonName | translit}}</span>
              @if (randomBirthday.birthYear) {
              <span class="bcard-meta gagalin">
                {{randomBirthday.birthYear}}@if (randomBirthday.city) {, {{randomBirthday.city | translit}}}
              </span>
              }
            </div>

            <!-- Side right -->
            @if (nextBirthday) {
            <div class="bcard bcard-side bcard-right"
              (click)="nextBirthdayClick($event)">
              <img class="bcard-side-img"
                loading="lazy"
                [src]="nextBirthday.imagePath"
                [alt]="nextBirthday.commonName">
            </div>
            }

          </div>
        </div>

        <!-- Footer -->
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            @if (cards.length > 1) {
            <button class="nav-arrow"
              (click)="prevBirthdayClick($event)">&#8249;</button>
            <button class="nav-arrow"
              (click)="nextBirthdayClick($event)">&#8250;</button>
            }
          </div>
          <button class="dash-card-btn"
            (click)="goToCalendar()">
            <mat-icon>open_in_new</mat-icon>
            {{'Детаљније' | translit}}
          </button>
        </div>

      </div>
      }
      }
    </div>

    <!-- Map -->
    <div class="dash-map-area">
      <ng-container *ngTemplateOutlet="logoTemplate" />
      <app-serbian-map [biggerMap]="biggerMap" />
    </div>

    <!-- Quote of the day -->
    <div class="slot dc-2">
      @defer (on idle) {
      @if (randomQuote) {
      <div class="dash-card">
        <div class="dash-card-header"
          (click)="goToPerson(randomQuote.authorSlug!)">
          <span class="dash-card-title">{{'Цитати познатих' | translit}}</span>
          <span class="dash-card-subtitle">{{randomQuote.authorName | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="quote-main">
            @if (randomQuoteAuthorImage) {
            <img class="quote-author-bg"
              [src]="randomQuoteAuthorImage"
              [alt]="randomQuote.authorName"
              aria-hidden="true">
            }
            <p class="quote-text">{{randomQuote.text | trimWord | translit}}</p>
          </div>
        </div>
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            @if (dailyQuotes.length > 1) {
            <button class="nav-arrow nav-prev"
              (click)="prevQuoteClick($event)">&#8249;</button>
            <button class="nav-arrow nav-next"
              (click)="nextQuoteClick($event)">&#8250;</button>
            }
          </div>
          <button class="dash-card-btn"
            (click)="goToQuotes()">
            <mat-icon>open_in_new</mat-icon>
            {{'Детаљније' | translit}}
          </button>
        </div>
      </div>
      }
      }
    </div>
  </div>

  <!-- BELOW: remaining cards -->
  <div class="dashboard-below">
    @defer (on idle) {

    <!-- On this day -->
    <div class="slot">
      @if (randomEvent) {
      <div class="dash-card">
        <div class="dash-card-header"
          (click)="goToEvents()">
          <span class="dash-card-title">{{'Догађаји и празници' | translit}}</span>
          <span class="dash-card-subtitle">{{eventDateDisplay | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="card-media-row"
            (click)="goToEvents()">
            <div class="card-media-img-wrap">
              <img loading="lazy"
                class="border-img"
                [src]="randomEvent.imagePath"
                [alt]="randomEvent.title || randomEvent.name">
            </div>
            <div class="card-media-text">
              <span class="card-media-name">{{(randomEvent.title || randomEvent.name) | translit}}</span>
              @if (randomEvent.description) {
              <p class="card-media-desc">{{randomEvent.description | translit}}</p>
              }
            </div>
          </div>
        </div>
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            @if (dailyEvents.length > 1) {
            <button class="nav-arrow nav-prev"
              (click)="prevEventClick($event)">&#8249;</button>
            <button class="nav-arrow nav-next"
              (click)="nextEventClick($event)">&#8250;</button>
            }
          </div>
          <button class="dash-card-btn"
            (click)="goToEvents()">
            <mat-icon>open_in_new</mat-icon>
            {{'Детаљније' | translit}}
          </button>
        </div>
      </div>
      } @else {
      <div class="dash-card">
        <div class="dash-card-header"
          (click)="goToEvents()">
          <span class="dash-card-title">{{'Догађаји и празници' | translit}}</span>
          <span class="dash-card-subtitle">{{eventDateDisplay | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="event-slot-empty">
            <mat-icon class="no-events-icon">event_busy</mat-icon>
            <p>{{'Нема историјских догађаја' | translit}}</p>
            <p>{{'за данашњи дан.' | translit}}</p>
          </div>
        </div>
        <button class="dash-card-btn"
          (click)="goToEvents()">
          <mat-icon>open_in_new</mat-icon>
          {{'Детаљније' | translit}}
        </button>
      </div>
      }
    </div>

    <!-- State chronology -->
    <div class="slot">
      <div class="dash-card">
        <div class="dash-card-header"
          (click)="onTimeline()">
          <span class="dash-card-title">{{'Кључне године' | translit}}</span>
          <span class="dash-card-subtitle">{{'Развој српске државе' | translit}}</span>
        </div>
        <div class="dash-card-body">
          @if (randomTimelineEvent) {
          <div class="timeline-content"
            (click)="onTimeline()">
            @if (randomTimelineEvent.imagePath) {
            <div class="timeline-img-bg"
              [style.backgroundImage]="'url(' + randomTimelineEvent.imagePath + ')'"></div>
            }
            <div class="timeline-text-overlay">
              <span class="timeline-year gagalin">{{randomTimelineEvent.age}}</span>
              <div class="timeline-bottom">
                <span class="timeline-title">{{randomTimelineEvent.title | translit}}</span>
                @if (randomTimelineEvent.innerHtml) {
                <p class="timeline-description">
                  {{randomTimelineEvent.innerHtml | removeHtmlTags | translit}}
                </p>
                }
              </div>
            </div>
          </div>
          }
        </div>
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            @if (timelineEvents.length > 1) {
            <button class="nav-arrow nav-prev"
              (click)="prevTimelineClick($event)">&#8249;</button>
            <button class="nav-arrow nav-next"
              (click)="nextTimelineClick($event)">&#8250;</button>
            }
          </div>
          <button class="dash-card-btn"
            (click)="onTimeline()">
            <mat-icon>open_in_new</mat-icon>
            {{'Детаљније' | translit}}
          </button>
        </div>
      </div>
    </div>

    <!-- Landmarks -->
    <div class="slot">
      <div class="dash-card">
        <div class="dash-card-header"
          (click)="onHeritageBox(randomHeritage.path)">
          <span class="dash-card-title">{{'Знаменитости' | translit}}</span>
          <span class="dash-card-subtitle">{{'Упознајте богато наслеђе Србије' | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="item-rotate-row">
            <div class="item-rotate-main"
              (click)="onHeritageBox(randomHeritage.path)">
              <img loading="lazy"
                class="cover"
                [src]="randomHeritage.imagePath"
                [alt]="randomHeritage.title">
              <span class="item-rotate-name">{{randomHeritage.title | translit}}</span>
            </div>
          </div>
        </div>
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            <button class="nav-arrow nav-prev"
              (click)="prevHeritageClick($event)">&#8249;</button>
            <button class="nav-arrow nav-next"
              (click)="nextHeritageClick($event)">&#8250;</button>
          </div>
          <button class="dash-card-btn"
            (click)="onHeritage()">
            <mat-icon>open_in_new</mat-icon>
            {{'Детаљније' | translit}}
          </button>
        </div>
      </div>
    </div>

    <!-- Did you know? -->
    <div class="slot">
      @if (randomFunfact) {
      <div class="dash-card">
        <div class="dash-card-header"
          (click)="onFunFactBox(randomFunfact)">
          <span class="dash-card-title">{{'Да ли сте знали?' | translit}}</span>
          <span class="dash-card-subtitle">{{'Занимљивости о Србији' | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="card-media-row"
            (click)="onFunFactBox(randomFunfact)">
            @if (randomFunfact.imagePath) {
            <div class="card-media-img-wrap">
              <img loading="lazy"
                class="border-img"
                [src]="randomFunfact.imagePath"
                [alt]="randomFunfact.title">
            </div>
            }
            <div class="card-media-text">
              <span class="card-media-name">{{randomFunfact.title | translit}}</span>
              @if (randomFunfact.description) {
              <p class="card-media-desc">{{randomFunfact.description | translit}}</p>
              }
            </div>
          </div>
        </div>
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            @if (funfactBoxes.length > 1) {
            <button class="nav-arrow nav-prev"
              (click)="prevFunfactClick($event)">&#8249;</button>
            <button class="nav-arrow nav-next"
              (click)="nextFunfactClick($event)">&#8250;</button>
            }
          </div>
          <button class="dash-card-btn"
            (click)="onFunFactBox(randomFunfact)">
            <mat-icon>open_in_new</mat-icon>
            {{'Детаљније' | translit}}
          </button>
        </div>
      </div>
      }
    </div>

    <!-- Historical collections -->
    <div class="slot">
      <div class="dash-card">
        <div class="dash-card-header"
          (click)="onChronologyBox(randomChronology.path)">
          <span class="dash-card-title">{{'Хроника' | translit}}</span>
          <span class="dash-card-subtitle">{{'Кључни тренуци у историји Србије' | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="item-rotate-row">
            <div class="item-rotate-main"
              (click)="onChronologyBox(randomChronology.path)">
              <img loading="lazy"
                class="cover"
                [src]="randomChronology.imagePath"
                [alt]="randomChronology.title">
              <span class="item-rotate-name">{{randomChronology.title | translit}}</span>
            </div>
          </div>
        </div>
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            <button class="nav-arrow nav-prev"
              (click)="prevChronologyClick($event)">&#8249;</button>
            <button class="nav-arrow nav-next"
              (click)="nextChronologyClick($event)">&#8250;</button>
          </div>
          <button class="dash-card-btn"
            (click)="onChronology()">
            <mat-icon>open_in_new</mat-icon>
            {{'Детаљније' | translit}}
          </button>
        </div>
      </div>
    </div>

    <!-- Cities and municipalities -->
    <div class="slot">
      @if (randomCity) {
      <div class="dash-card">
        <div class="dash-card-header"
          (click)="onTag()">
          <span class="dash-card-title">{{'Градови и општине' | translit}}</span>
          <span class="dash-card-subtitle">{{'Упознај места у Србији' | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="item-rotate-row">
            <div class="item-rotate-main"
              (click)="onTagBox(randomCity.link)">
              <img loading="lazy"
                [src]="randomCity.imagePath"
                [alt]="randomCity.title">
              <span class="item-rotate-name">{{randomCity.title | translit}}</span>
            </div>
          </div>
        </div>
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            <button class="nav-arrow"
              (click)="prevCityClick($event)">&#8249;</button>
            <button class="nav-arrow"
              (click)="nextCityClick($event)">&#8250;</button>
          </div>
          <button class="dash-card-btn"
            (click)="onTag()">
            <mat-icon>open_in_new</mat-icon>
            {{'Детаљније' | translit}}
          </button>
        </div>
      </div>
      }
    </div>


    <!-- Featured songs -->
    <div class="slot slot-song">
      @if (randomSong) {
      <div class="dash-card">
        <div class="dash-card-header"
          (click)="onSong(randomSong)">
          <span class="dash-card-title">{{'Најлепша српска поезија' | translit}}</span>
          <span class="dash-card-subtitle">{{randomSong.authorName | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="timeline-content song-content"
            (click)="onSong(randomSong)">
            <div class="timeline-text-overlay">
              <div class="timeline-bottom">
                <span class="timeline-title">{{randomSong.title | translit}}</span>
                @if (randomSong.innerHtml) {
                <p class="timeline-description"
                  [innerHTML]="randomSong.innerHtml"></p>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            @if (songList.length > 1) {
            <button class="nav-arrow nav-prev"
              (click)="prevSongClick($event)">&#8249;</button>
            <button class="nav-arrow nav-next"
              (click)="nextSongClick($event)">&#8250;</button>
            }
          </div>
          <button class="dash-card-btn"
            (click)="onSong(randomSong)">
            <mat-icon>open_in_new</mat-icon>
            {{'Детаљније' | translit}}
          </button>
        </div>
      </div>
      }
    </div>

    <!-- Categories -->
    <div class="slot">
      @if (categoryList.length) {
      <div class="dash-card">
        <div class="dash-card-header"
          (click)="onCategories()">
          <span class="dash-card-title">{{'Категорије' | translit}}</span>
          <span class="dash-card-subtitle">{{'Личности српске историје' | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="name-list">
            @for (cat of categoryPageItems; track cat.id) {
            <div class="category-list-item"
              (click)="onCategory(cat.slug!)">
              @if (cat.imagePath) {
              <div class="category-list-icon-wrap">
                <img class="category-list-img"
                  loading="lazy"
                  [src]="cat.imagePath"
                  [alt]="cat.name">
              </div>
              }
              <span class="name-list-text">{{cat.name | translit}}</span>
            </div>
            }
          </div>
        </div>
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            <button class="nav-arrow"
              (click)="prevCategoryPage()">&#8249;</button>
            <span class="page-indicator">{{categoryPageIndex() + 1}}&thinsp;/&thinsp;{{categoryTotalPages}}</span>
            <button class="nav-arrow"
              (click)="nextCategoryPage()">&#8250;</button>
          </div>
          <button class="dash-card-btn"
            (click)="onCategories()">
            <mat-icon>open_in_new</mat-icon>
            {{'Детаљније' | translit}}
          </button>
        </div>
      </div>
      }
    </div>

    <!-- Surnames -->
    <div class="slot">
      <div class="dash-card surname-card">
        <div class="dash-card-header"
          (click)="onSurnames()">
          <span class="dash-card-title">{{'Регистар презимена' | translit}}</span>
          <span class="dash-card-subtitle">{{'Нађи своје презимењаке' | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="name-list">
            @for (item of surnamePageItems; track item.title) {
            <div class="name-list-item"
              (click)="onSurname(item.slug)">
              <span class="name-list-text">{{item.title | translit}}</span>
              <span class="name-list-count">{{item.elements.length}}</span>
            </div>
            }
          </div>
        </div>
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            <button class="nav-arrow"
              (click)="prevSurnamePage()">&#8249;</button>
            <span class="page-indicator">{{surnamePageIndex() + 1}}&thinsp;/&thinsp;{{surnameTotalPages}}</span>
            <button class="nav-arrow"
              (click)="nextSurnamePage()">&#8250;</button>
          </div>
          <button class="dash-card-btn"
            (click)="onSurnames()">
            <mat-icon>open_in_new</mat-icon>
            {{'Детаљније' | translit}}
          </button>
        </div>
      </div>
    </div>

    <!-- Female first names -->
    <div class="slot">
      <div class="dash-card female-card">
        <div class="dash-card-header"
          (click)="onFirstnames()">
          <span class="dash-card-title">{{'Регистар женских имена' | translit}}</span>
          <span class="dash-card-subtitle">{{'Претражи Српкиње по имену' | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="name-list">
            @for (item of femaleNamePageItems; track item.title) {
            <div class="name-list-item"
              (click)="onFirstname(item.slug)">
              <span class="name-list-text">{{item.title | translit}}</span>
              <span class="name-list-count">{{item.elements.length}}</span>
            </div>
            }
          </div>
        </div>
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            <button class="nav-arrow"
              (click)="prevFemaleNamePage()">&#8249;</button>
            <span class="page-indicator">{{femaleNamePageIndex() + 1}}&thinsp;/&thinsp;{{femaleNameTotalPages}}</span>
            <button class="nav-arrow"
              (click)="nextFemaleNamePage()">&#8250;</button>
          </div>
          <button class="dash-card-btn"
            (click)="onFirstnames()">
            <mat-icon>open_in_new</mat-icon>
            {{'Детаљније' | translit}}
          </button>
        </div>
      </div>
    </div>

    <!-- Male first names -->
    <div class="slot">
      <div class="dash-card male-card">
        <div class="dash-card-header"
          (click)="onFirstnames()">
          <span class="dash-card-title">{{'Регистар мушких имена' | translit}}</span>
          <span class="dash-card-subtitle">{{'Претражи Србе по имену' | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="name-list">
            @for (item of maleNamePageItems; track item.title) {
            <div class="name-list-item"
              (click)="onFirstname(item.slug)">
              <span class="name-list-text">{{item.title | translit}}</span>
              <span class="name-list-count">{{item.elements.length}}</span>
            </div>
            }
          </div>
        </div>
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            <button class="nav-arrow"
              (click)="prevMaleNamePage()">&#8249;</button>
            <span class="page-indicator">{{maleNamePageIndex() + 1}}&thinsp;/&thinsp;{{maleNameTotalPages}}</span>
            <button class="nav-arrow"
              (click)="nextMaleNamePage()">&#8250;</button>
          </div>
          <button class="dash-card-btn"
            (click)="onFirstnames()">
            <mat-icon>open_in_new</mat-icon>
            {{' Детаљније' | translit}}
          </button>
        </div>
      </div>
    </div>

    <!-- Instagram -->
    <div class="slot">
      <div class="dash-card">
        <div class="dash-card-header"
          (click)="onInstragram()">
          <span class="dash-card-title">{{'Инстаграм објаве' | translit}}</span>
          <span class="dash-card-subtitle">{{randomInstagram.name | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="heritage-hero"
            (click)="onInstagramBox(randomInstagram.link)">
            <div class="heritage-hero-bg"
              [style.backgroundImage]="randomInstagram.image"></div>
            <div class="heritage-hero-overlay"></div>
          </div>
        </div>
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            <button class="nav-arrow nav-prev"
              (click)="prevInstagramClick($event)">&#8249;</button>
            <button class="nav-arrow nav-next"
              (click)="nextInstagramClick($event)">&#8250;</button>
          </div>
          <button class="dash-card-btn"
            (click)="onInstragram()">
            <mat-icon>open_in_new</mat-icon>
            {{'Детаљније' | translit}}
          </button>
        </div>
      </div>
    </div>


    <!-- Tags -->
    <div class="slot">
      @if (randomTag) {
      <div class="dash-card">
        <div class="dash-card-header"
          (click)="onTag()">
          <span class="dash-card-title">{{'Популарни тагови' | translit}}</span>
          <span class="dash-card-subtitle">{{'Истражите области интересовања' | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="item-rotate-row">
            <div class="item-rotate-main"
              (click)="onTagBox(randomTag.link)">
              <img loading="lazy"
                [src]="randomTag.imagePath"
                [alt]="randomTag.title">
              <span class="item-rotate-name">{{randomTag.title | translit}}</span>
            </div>
          </div>
        </div>
        <div class="dash-card-footer-row">
          <div class="dash-card-nav">
            <button class="nav-arrow"
              (click)="prevTagClick($event)">&#8249;</button>
            <button class="nav-arrow"
              (click)="nextTagClick($event)">&#8250;</button>
          </div>
          <button class="dash-card-btn"
            (click)="onTag()">
            <mat-icon>open_in_new</mat-icon>
            {{'Детаљније' | translit}}
          </button>
        </div>
      </div>
      }
    </div>

    <!-- Daily quiz -->
    <div class="slot">
      <div class="dash-card">
        <div class="dash-card-header"
          (click)="onQuiz()">
          <span class="dash-card-title">{{'Дневни квиз' | translit}}</span>
          <span class="dash-card-subtitle">{{'Тестирај своје знање' | translit}}</span>
        </div>
        <div class="dash-card-body">
          <div class="quiz-inline-body">
            @if (!totalScore) {
            <p class="quiz-inline-text">
              {{'Сваког дана те чека' | translit}}
              <b>{{'5 игара' | translit}}</b>
              <br>
              {{'са новим питањима.' | translit}}
              <br>
              <br>
              <mat-icon class="quiz-icon">quiz</mat-icon>
              <mat-icon class="quiz-icon">quiz</mat-icon>
              <mat-icon class="quiz-icon">quiz</mat-icon>
              <mat-icon class="quiz-icon">quiz</mat-icon>
              <mat-icon class="quiz-icon">quiz</mat-icon>
              <br>
              <br>
              <b>{{'Jедном дневно' | translit}}</b>
              {{'можеш да играш,' | translit}}
              <br>
              {{'зато се добро фокусираj!' | translit}}
            </p>
            } @else {
            <p class="quiz-score-title">{{'Данашњи учинак:' | translit}}</p>
            <div class="quiz-score-list">
              @for (points of gamePoints; track $index) {
              <div class="quiz-score-row">
                <span class="quiz-game-name">{{$index + 1}}. {{'игра' | translit}}</span>
                <span class="quiz-game-pts">{{points}}</span>
              </div>
              }
            </div>
            @if (gamePoints[4] != null) {
            <p class="quiz-total">
              {{'Укупно:' | translit}} <b>{{totalScore}}</b> {{'поена' | translit}}
            </p>
            } @else {
            <p class="quiz-total quiz-unfinished">
              {{'Нисте завршили данашњи квиз.' | translit}}
            </p>
            }
            }
          </div>
        </div>
        <button class="dash-card-btn"
          (click)="onQuiz()">
          <mat-icon>sports_esports</mat-icon>
          {{'Хајде да се играмо' | translit}}
        </button>
      </div>
    </div>

    <!-- Site statistics -->
    <div class="slot">
      <div class="dash-card">
        <div class="dash-card-header">
          <span class="dash-card-title">{{'Статистика сајта' | translit}}</span>
          <span class="dash-card-subtitle">{{'наша база података' | translit}}</span>
        </div>
        <app-stats-counter [borderless]="true" />
      </div>
    </div>

    }
  </div>



  <!-- Greatest Serbs -->
  @if (tileList.length && centerGreatest) {
  <section class="greatest-section">

    <div class="greatest-header">
      <h2 class="greatest-title gagalin">{{'Српски великани' | translit}}</h2>
      <p class="greatest-subtitle">{{'Славне личности које су обликовале' | translit}}
        <span class="greatest-subtitle-gold">{{'историју Србије' | translit}}</span>
      </p>
      <div class="greatest-title-line"></div>
    </div>

    <div class="greatest-stage"
      (touchstart)="onGreatestTouchStart($event)"
      (touchend)="onGreatestTouchEnd($event)">

      <!--     <div class="greatest-backdrop"
        [style.backgroundImage]="'url(' + centerGreatest.imagePath + ')'"></div>  -->

      <div class="greatest-backdrop"></div>
      <div class="greatest-backdrop-overlay"></div>

      <div class="greatest-cards">

        <!-- Prev stack (up to 3) -->
        @if (prevGreatestList.length) {
        <div class="gcard-stack gcard-stack-left">
          @for (person of prevGreatestList; track person.id) {
          <div class="gcard gcard-side bcard bcard-side"
            (click)="prevGreatestClick($event)">
            <img class="bcard-side-img"
              loading="lazy"
              [src]="person.imagePath"
              [alt]="person.commonName">
          </div>
          }
        </div>
        }

        <!-- Center card -->
        <div class="gcard gcard-center bcard bcard-center"
          (click)="goToPerson(centerGreatest.slug!)">
          <div class="bcard-portrait">
            <img loading="lazy"
              [src]="centerGreatest.imagePath"
              [alt]="centerGreatest.commonName">
          </div>
        </div>

        <!-- Next stack (up to 3) -->
        @if (nextGreatestList.length) {
        <div class="gcard-stack gcard-stack-right">
          @for (person of nextGreatestList; track person.id) {
          <div class="gcard gcard-side bcard bcard-side"
            (click)="nextGreatestClick($event)">
            <img class="bcard-side-img"
              loading="lazy"
              [src]="person.imagePath"
              [alt]="person.commonName">
          </div>
          }
        </div>
        }

      </div>

      <div class="name-row">
        <span class="bcard-name">{{centerGreatest.commonName | translit}}</span>
        @if (centerGreatest.birthYear) {
        <span class="bcard-meta gagalin">
          {{centerGreatest.birthYear}}@if (centerGreatest.city) {, {{centerGreatest.city | translit}}}
        </span>
        }
      </div>

      <div class="greatest-counter-row">
        <button class="greatest-nav greatest-nav-prev"
          (click)="prevGreatestClick($event)">&#8249;</button>
        <button class="greatest-dice"
          (click)="randomizeGreatest()">
          <mat-icon>casino</mat-icon>
        </button>
        <span class="greatest-counter">{{greatestIndex + 1}} / {{tileList.length}}</span>
        <button class="greatest-nav greatest-nav-next"
          (click)="nextGreatestClick($event)">&#8250;</button>
      </div>

    </div>

  </section>
  }
</div>

<ng-template #logoTemplate>
  <div class="logo-wrapper">
    @if (themeService.isLightMode() && themeService.isCyrillicMode()) {
    <img loading="eager"
      fetchpriority="high"
      src="assets/images/gallery-logo-text-outline.png"
      alt="Logo Galerija" />
    }

    @if (themeService.isDarkMode() && themeService.isCyrillicMode()) {
    <img loading="eager"
      fetchpriority="high"
      src="assets/images/gallery-logo-gold.png"
      alt="Logo Galerija" />
    }

    @if (themeService.isLightMode() && themeService.isLatinMode()) {
    <img loading="eager"
      fetchpriority="high"
      src="assets/images/gallery-logo-text-latin.png"
      alt="Logo Galerija" />
    }

    @if (themeService.isDarkMode() && themeService.isLatinMode()) {
    <img loading="eager"
      fetchpriority="high"
      src="assets/images/gallery-logo-text-latin.png"
      alt="Logo Galerija" />
    }
  </div>
</ng-template>